const ShareFeedbackSection = () => {
    return (
        <section className="basic-area share-qr-area">
            <div className="container">
                <div className="basic-flex basic-flex--reverse share-qr">
                    <img
                        className="basic-flex__image"
                        src="/images/feedback.gif"
                        alt="share QR"
                    />

                    <div className="basic-flex__content">
                        <h2>Get more feedback with quick and easy rating questions</h2>

                        <div>
                            Share the QR code or the short link with your peers
                            or audience to get feedback.<br /><br /> We use Likert questions to gather user sentiment and feedback to put together a Likert scale.  Katalife presents a statement and asks respondents to indicate their level of agreement or disagreement on a symmetric scale, ranging from “strongly disagree” to “strongly agree.”
                            <br /><br></br><h3>Give it a try</h3> 
                            <div className="demo-qr-code-container" style={{ display: "flex", flexDirection: "row", alignItems: "center" }} >
                                <div style={{ width: "120px", height: "120px",backgroundColor: "white", borderRadius: "10px", padding: "10px", marginTop: "20px", marginBottom: "10px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    <img style={{ width: "100px", height: "100px",  }} src="/images/katalife-qr-code-demo-cafe.png" alt="Katalife demo cafe survey QR Code" />          </div>                     
                                <span style={{ paddingLeft: "20px" }}>Restaurant / Cafe</span>
                            </div>
                            <div className="demo-qr-code-container" style={{ display: "flex", flexDirection: "row", alignItems: "center" }} >
                                <div style={{ width: "120px", height: "120px",backgroundColor: "white", borderRadius: "10px", padding: "10px", marginTop: "20px", marginBottom: "10px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    <img style={{ width: "100px", height: "100px",  }} src="/images/katalife-qr-code-demo-presentation.png" alt="Katalife demo presentation survey QR Code" />          </div>                     
                                <span style={{ paddingLeft: "20px" }}> Presentation </span>
                            </div>
                            <div className="demo-qr-code-container" style={{ display: "flex", flexDirection: "row", alignItems: "center" }} >
                                <div style={{ width: "120px", height: "120px",backgroundColor: "white", borderRadius: "10px", padding: "10px", marginTop: "20px", marginBottom: "10px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    <img style={{ width: "100px", height: "100px",  }} src="/images/katalife-qr-code-demo-360feedback.png" alt="Katalife demo 360 feedback survey QR Code" />          </div>                     
                                <span style={{ paddingLeft: "20px" }}> 360 Feedback / Peer feedback </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ShareFeedbackSection;
